import React, { useState, useEffect, useRef } from 'react';
import { FaUser, FaEnvelope, FaPhone, FaCalendar, FaClock, FaUserShield, FaEdit, FaSave, FaTimes, FaServer, FaKey, FaAt, FaPaperPlane, FaBuilding, FaCamera, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
const API_URL = '/api';
const Profile = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [successMsg, setSuccessMsg] = useState('');
  const [smtpSettings, setSmtpSettings] = useState(null);
  const [smtpForm, setSmtpForm] = useState({ host: '', port: '', user: '', pass: '', from: '' });
  const [smtpLoading, setSmtpLoading] = useState(false);
  const [smtpError, setSmtpError] = useState('');
  const [smtpSuccess, setSmtpSuccess] = useState('');
  const [smtpMode, setSmtpMode] = useState('view');
  
  // Company logo states
  const [companyLogoBase64, setCompanyLogoBase64] = useState(null);

  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
  const [logoUploading, setLogoUploading] = useState(false);
  const [logoError, setLogoError] = useState('');
  const [removeLogo, setRemoveLogo] = useState(false); // New state for logo removal
  const fileInputRef = useRef(null);
  
  const navigate = useNavigate();
  useEffect(() => {
    fetchUserProfile();
  }, []);

  useEffect(() => {
  if (userProfile && userProfile.CompanyLogo) {
    // Handle both raw base64 or already prefixed base64
    const logo =
      userProfile.CompanyLogo.startsWith("data:image")
        ? userProfile.CompanyLogo
        : `data:image/png;base64,${userProfile.CompanyLogo}`;

    setCompanyLogoPreview(logo);
  } else {
    setCompanyLogoPreview(null);
  }

  if (
    userProfile &&
    userProfile.Role &&
    userProfile.Role.toLowerCase() === "superadmin"
  ) {
    fetchSmtpSettings();
  }
}, [userProfile]);

useEffect(() => {
  if (userProfile) {
    console.log("🔹 userProfile from API:", userProfile);
    console.log("🔹 Raw CompanyLogo from DB:", userProfile.CompanyLogo);

    if (userProfile.CompanyLogo) {
      // Ensure base64 has the correct prefix
      const logo = userProfile.CompanyLogo.startsWith("data:image")
        ? userProfile.CompanyLogo
        : `data:image/png;base64,${userProfile.CompanyLogo}`;

      console.log("🔹 Final logo string (for <img>):", logo);

      setCompanyLogoPreview(logo);
    } else {
      setCompanyLogoPreview(null);
    }

    // Superadmin extra settings
    if (userProfile.Role && userProfile.Role.toLowerCase() === "superadmin") {
      fetchSmtpSettings();
    }
  }
}, [userProfile]);

  const fetchUserProfile = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_URL}/profile`, {
        headers: token ? { 'Authorization': `Bearer ${token}` } : {}
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setUserProfile(data.user);
        setEditForm(data.user);
      } else {
        setError(data.message || 'Failed to fetch profile');
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch profile');
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = () => {
    setIsEditing(true);
    setSuccessMsg('');
    setRemoveLogo(false); // Reset remove logo flag
  };
   

const handleCancel = () => {
  setIsEditing(false);
  setCompanyLogoBase64(null);
  setRemoveLogo(false);
  if (userProfile?.CompanyLogo) {
    const logo =
      userProfile.CompanyLogo.startsWith('data:image')
        ? userProfile.CompanyLogo
        : `data:image/png;base64,${userProfile.CompanyLogo}`;
    setCompanyLogoPreview(logo);
  } else {
    setCompanyLogoPreview(null);
  }
};

const handleSave = async () => {
  try {
    setLoading(true);
    setError('');
    setSuccessMsg('');

    // Make sure a logo is selected or marked for removal
    if (!companyLogoBase64 && !removeLogo) {
      setError('Please select a logo or remove the existing one');
      return;
    }

    const payload = {
      CompanyLogoBase64: companyLogoBase64,
      RemoveLogo: removeLogo
    };

    const token = localStorage.getItem('authToken');
    const res = await fetch(`${API_URL}/profile/logo`, {  // ✅ Updated endpoint
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
      },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    if (res.ok && data.success) {
      setUserProfile(data.user);
      setIsEditing(false);
      setSuccessMsg('Company logo updated successfully!');
      setCompanyLogoBase64(null);
      setRemoveLogo(false);
    } else {
      setError(data.message || 'Failed to update logo');
    }
  } catch (err) {
    setError(err.message || 'Failed to update logo');
  } finally {
    setLoading(false);
  }
};

// Update handleLogoChange to store in companyLogoBase64
const handleLogoChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  if (!file.type.match('image.*')) {
    setLogoError('Please select an image file');
    return;
  }
  if (file.size > 5 * 1024 * 1024) {
    setLogoError('File size must be less than 5MB');
    return;
  }

  setLogoError('');
  setRemoveLogo(false);

  const reader = new FileReader();
  reader.onloadend = () => {
    setCompanyLogoBase64(reader.result); // ✅ store Base64
    setCompanyLogoPreview(reader.result); // show preview
  };
  reader.readAsDataURL(file);
};

// Logo removal
const handleRemoveLogo = () => {
  setCompanyLogoBase64(null);
  setRemoveLogo(true);
  setCompanyLogoPreview(null);
  setLogoError('');
};

  
  // SMTP SETTINGS (Admin only)
  const fetchSmtpSettings = async () => {
    setSmtpLoading(true);
    setSmtpError('');
    setSmtpSuccess('');
    try {
      const res = await fetch(`${API_URL}/smtp-settings`);
      if (res.ok) {
        const data = await res.json();
        if (data && data.settings) {
          setSmtpSettings(data.settings);
          setSmtpForm(data.settings);
          setSmtpMode('view');
        } else {
          setSmtpSettings(null);
          setSmtpForm({ host: '', port: '', user: '', pass: '', from: '' });
          setSmtpMode('add');
        }
      }
    } catch (err) {
      setSmtpError('Failed to fetch SMTP settings');
    } finally {
      setSmtpLoading(false);
    }
  };
  const handleSmtpInputChange = (field, value) => {
    setSmtpForm(prev => ({ ...prev, [field]: value }));
  };
  const handleSmtpSave = async () => {
    setSmtpLoading(true);
    setSmtpError('');
    setSmtpSuccess('');
    try {
      const res = await fetch(`${API_URL}/smtp-settings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(smtpForm)
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSmtpSuccess('SMTP settings saved successfully!');
        setSmtpSettings(smtpForm);
        setSmtpMode('view');
      } else {
        setSmtpError(data.message || 'Failed to save SMTP settings');
      }
    } catch (err) {
      setSmtpError('Failed to save SMTP settings');
    } finally {
      setSmtpLoading(false);
    }
  };
  const formatDate = (dateString) => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);

  return date.toLocaleString('en-US', {
    timeZone: 'UTC',   // 🚀 Force treat DB time as local
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });
};



  const getStatusColor = (isActive) => {
    return isActive ? 'text-green-600 bg-green-100' : 'text-red-600 bg-red-100';
  };
  const getRoleColor = (role) => {
    const roleColors = {
      'Superadmin': 'bg-purple-100 text-purple-800',
      'User': 'bg-blue-100 text-blue-800',
      'Manager': 'bg-orange-100 text-orange-800',
      'Vendor': 'bg-green-100 text-green-800',
      'default': 'bg-gray-100 text-gray-800'
    };
    return roleColors[role] || roleColors.default;
  };
  const handleLogout = () => {
    navigate('/login');
  };
  if (loading) {
    return (
      <div className="min-h-screen flex bg-[#E5E1DA]">
        <Sidebar onLogout={handleLogout} />
        <main className="flex-1 p-8 ml-16 overflow-y-auto">
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#2b6777] mx-auto mb-4"></div>
              <p className="text-[#2b6777] text-lg font-semibold">Loading profile...</p>
            </div>
          </div>
        </main>
      </div>
    );
  }
  if (error) {
    return (
      <div className="min-h-screen flex bg-[#E5E1DA]">
        <Sidebar onLogout={handleLogout} />
        <main className="flex-1 p-8 ml-16 overflow-y-auto">
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                <p className="font-bold">Error</p>
                <p>{error}</p>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
  return (
  <div className="min-h-screen flex bg-[#E5E1DA]">
    <Sidebar onLogout={handleLogout} />
    <main className="flex-1 p-2 md:p-8 overflow-hidden ml-0 md:ml-16 transition-all duration-300">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-6 md:mb-8 animate-fade-in text-center md:text-left">
  <h1 className="text-2xl md:text-4xl font-bold text-[#2b6777] mb-2">
    User Profile
  </h1>
  <p className="text-[#52ab98] text-base md:text-lg">
    Manage your account information
  </p>
</div>

        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {/* Profile Card */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 transform hover:scale-[1.02] transition-all duration-300 animate-slide-in-left">
              <div className="text-center mb-6">
                {/* Always show user icon, not company logo */}
                <div className="w-24 h-24 md:w-32 md:h-32 mx-auto mb-4 bg-gradient-to-br from-[#2b6777] to-[#52ab98] rounded-full flex items-center justify-center shadow-lg">
                  <FaUser className="text-4xl md:text-6xl text-white" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-[#2b6777] mb-2">
                  {userProfile?.FullName || 'User Name'}
                </h2>
                <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getRoleColor(userProfile?.Role)}`}>
                  {userProfile?.Role || 'User'}
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                  <FaEnvelope className="text-[#52ab98] text-lg" />
                  <div className="min-w-0 flex-1">
                    <p className="text-sm text-gray-600">Email</p>
                    <p className="font-medium text-[#2b6777] truncate">{userProfile?.Email}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                  <FaPhone className="text-[#52ab98] text-lg" />
                  <div>
                    <p className="text-sm text-gray-600">Phone</p>
                    <p className="font-medium text-[#2b6777]">{userProfile?.Phone || 'N/A'}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg">
                  <FaUserShield className="text-[#52ab98] text-lg" />
                  <div>
                    <p className="text-sm text-gray-600">Status</p>
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(userProfile?.IsActive)}`}>
                      {userProfile?.IsActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Details Card */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 animate-slide-in-right">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-3">
                <h3 className="text-xl md:text-2xl font-bold text-[#2b6777]">Profile Details</h3>
                {!isEditing ? (
                  <button
                    onClick={handleEdit}
                    className="flex items-center space-x-2 bg-[#52ab98] hover:bg-[#2b6777] text-white px-4 py-2 rounded-lg transition-all duration-200 transform hover:scale-105 w-full sm:w-auto justify-center"
                  >
                    <FaEdit />
                    <span>Edit Profile</span>
                  </button>
                ) : (
                  <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 w-full sm:w-auto">
                    <button
                      onClick={handleSave}
                      className="flex items-center justify-center space-x-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition-all duration-200"
                    >
                      <FaSave />
                      <span>Save</span>
                    </button>
                    <button
                      onClick={handleCancel}
                      className="flex items-center justify-center space-x-2 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-all duration-200"
                    >
                      <FaTimes />
                      <span>Cancel</span>
                    </button>
                  </div>
                )}
              </div>
              
              {/* Company Logo Section */}
              {/* Company Logo Section */}
<div className="mb-6">
  <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
    <FaBuilding className="mr-2 text-[#52ab98]" /> Company Logo
  </label>
  <div>
    <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4 mb-3">
      {companyLogoPreview ? (
        <img 
          src={companyLogoPreview} 
          alt="Company Logo" 
          className="w-24 h-24 object-contain border rounded-lg"
        />
      ) : (
        <div className="w-24 h-24 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg">
          <FaBuilding className="text-gray-400 text-2xl" />
        </div>
      )}

      {isEditing && (
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <button
            type="button"
            onClick={() => fileInputRef.current.click()}
            className="bg-[#52ab98] hover:bg-[#2b6777] text-white px-4 py-2 rounded-lg flex items-center gap-2 shadow-md w-full sm:w-auto justify-center"
          >
            <FaCamera /> Choose Image
          </button>
          {companyLogoPreview && (
            <button
              type="button"
              onClick={handleRemoveLogo}
              className="bg-red-500 hover:bg-red-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 shadow-md w-full sm:w-auto justify-center"
            >
              <FaTrash /> Remove
            </button>
          )}
          <input
            type="file"
            accept="image/*"
            className="hidden"
            ref={fileInputRef}
            onChange={handleLogoChange}
          />
        </div>
      )}
    </div>
    {logoError && <p className="text-red-500 text-sm">{logoError}</p>}
    <p className="text-gray-500 text-sm">Accepted formats: JPG, PNG, GIF. Max size: 5MB.</p>
  </div>
</div>

              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Username</label>
                    
                      <div className="p-3 bg-gray-50 rounded-lg">
                        <p className="text-[#2b6777] font-medium">{userProfile?.Username}</p>
                      </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
                    
                      <div className="p-3 bg-gray-50 rounded-lg">
                        <p className="text-[#2b6777] font-medium">{userProfile?.FullName}</p>
                      </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                    
                      <div className="p-3 bg-gray-50 rounded-lg">
                        <p className="text-[#2b6777] font-medium">{userProfile?.Email}</p>
                      </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                    
                      <div className="p-3 bg-gray-50 rounded-lg">
                        <p className="text-[#2b6777] font-medium">{userProfile?.Phone || 'N/A'}</p>
                      </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Role</label>
                    <div className="p-3 bg-gray-50 rounded-lg">
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getRoleColor(userProfile?.Role)}`}>
                        {userProfile?.Role || 'User'}
                      </span>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Account Created</label>
                    <div className="flex items-center space-x-2 p-3 bg-gray-50 rounded-lg">
                      <FaCalendar className="text-[#52ab98]" />
                      <p className="text-[#2b6777] font-medium">{formatDate(userProfile?.CreatedAt)}</p>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Last Login</label>
                    <div className="flex items-center space-x-2 p-3 bg-gray-50 rounded-lg">
                      <FaClock className="text-[#52ab98]" />
                      <p className="text-[#2b6777] font-medium">{formatDate(userProfile?.LastLogin)}</p>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Account Status</label>
                    <div className="p-3 bg-gray-50 rounded-lg">
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(userProfile?.IsActive)}`}>
                        {userProfile?.IsActive ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Activity Summary */}
        <div className="mt-6 md:mt-8 bg-white rounded-2xl shadow-xl p-6 md:p-8 animate-fade-in-up">
          <h3 className="text-xl md:text-2xl font-bold text-[#2b6777] mb-6">Account Summary</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            <div className="text-center p-4 md:p-6 bg-gradient-to-br from-[#2b6777] to-[#52ab98] rounded-xl text-white transform hover:scale-[1.02] transition-all duration-300">
              <div className="text-sm md:text-l font-bold mb-2">{userProfile?.Email}</div>
              <div className="text-sm opacity-90">User Email</div>
            </div>
            <div className="text-center p-4 md:p-6 bg-gradient-to-br from-[#52ab98] to-[#c8d8e4] rounded-xl text-white transform hover:scale-[1.02] transition-all duration-300">
              <div className="text-2xl md:text-3xl font-bold mb-2">{userProfile?.Role || 'User'}</div>
              <div className="text-sm opacity-90">Role</div>
            </div>
            <div className="text-center p-4 md:p-6 bg-gradient-to-br from-[#c8d8e4] to-[#f2f2f2] rounded-xl text-[#2b6777] transform hover:scale-[1.02] transition-all duration-300">
              <div className="text-2xl md:text-3xl font-bold mb-2">{userProfile?.IsActive ? 'Active' : 'Inactive'}</div>
              <div className="text-sm opacity-90">Status</div>
            </div>
          </div>
        </div>
        
        {/* SMTP Settings Section (Admin Only) */}
        {userProfile && userProfile.Role && userProfile.Role.toLowerCase() === 'superadmin' && (
          <div className="mt-6 md:mt-8 bg-white rounded-2xl shadow-xl p-6 md:p-8 animate-fade-in-up">
            <h3 className="text-xl md:text-2xl font-bold text-[#2b6777] mb-6 flex items-center gap-2">
              <FaServer className="text-[#52ab98]" /> SMTP Email Settings
            </h3>
            {smtpError && <div className="bg-red-100 text-red-700 p-3 rounded-md mb-4 text-center">{smtpError}</div>}
            {smtpSuccess && <div className="bg-green-100 text-green-700 p-3 rounded-md mb-4 text-center">{smtpSuccess}</div>}
            {smtpLoading && (
              <div className="flex items-center gap-2 mb-4">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#2b6777]"></div>
                <span className="text-[#2b6777] font-medium">Loading SMTP settings...</span>
              </div>
            )}
            {/* VIEW MODE */}
            {smtpMode === 'view' && smtpSettings && !smtpLoading && (
              <div className="mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div className="flex items-center gap-2"><FaServer className="text-[#2b6777]" /><span className="font-semibold">Host:</span> <span className="truncate">{smtpSettings.host}</span></div>
                  <div className="flex items-center gap-2"><FaKey className="text-[#2b6777]" /><span className="font-semibold">Port:</span> <span>{smtpSettings.port}</span></div>
                  <div className="flex items-center gap-2"><FaUser className="text-[#2b6777]" /><span className="font-semibold">User:</span> <span className="truncate">{smtpSettings.user}</span></div>
                  <div className="flex items-center gap-2"><FaAt className="text-[#2b6777]" /><span className="font-semibold">From:</span> <span className="truncate">{smtpSettings.from}</span></div>
                </div>
                <div className="flex flex-col sm:flex-row gap-2">
                  <button
                    className="bg-[#52ab98] hover:bg-[#2b6777] text-white px-4 py-2 rounded-lg transition-all duration-200 flex items-center gap-2 justify-center"
                    onClick={() => { setSmtpForm(smtpSettings); setSmtpMode('edit'); setSmtpError(''); setSmtpSuccess(''); }}
                  >
                    <FaEdit /> Edit SMTP Settings
                  </button>
                  <button
                    className="bg-red-500 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-all duration-200 flex items-center gap-2 justify-center"
                    onClick={async () => {
                      setSmtpLoading(true);
                      setSmtpError('');
                      setSmtpSuccess('');
                      try {
                        const res = await fetch(`${API_URL}/smtp-settings`, { method: 'DELETE' });
                        const data = await res.json();
                        if (res.ok && data.success) {
                          setSmtpSuccess('SMTP settings deleted successfully!');
                          setSmtpSettings(null);
                          setSmtpForm({ host: '', port: '', user: '', pass: '', from: '' });
                          setSmtpMode('add');
                        } else {
                          setSmtpError(data.message || 'Failed to delete SMTP settings');
                        }
                      } catch (err) {
                        setSmtpError('Failed to delete SMTP settings');
                      } finally {
                        setSmtpLoading(false);
                      }
                    }}
                  >
                    <FaTimes /> Delete SMTP Settings
                  </button>
                </div>
              </div>
            )}
            {/* ADD MODE */}
            {smtpMode === 'add' && !smtpLoading && (
              <div>
                <button
                  className="bg-[#52ab98] hover:bg-[#2b6777] text-white px-4 py-2 rounded-lg transition-all duration-200 flex items-center gap-2 mb-4 justify-center"
                  onClick={() => { setSmtpForm({ host: '', port: '', user: '', pass: '', from: '' }); setSmtpMode('edit'); setSmtpError(''); setSmtpSuccess(''); }}
                >
                  <FaPaperPlane /> Add SMTP Settings
                </button>
              </div>
            )}
            {/* EDIT/ADD FORM */}
            {smtpMode === 'edit' && !smtpLoading && (
              <form
                className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 p-6 rounded-xl mb-4 border border-[#c8d8e4] shadow-sm animate-fade-in"
                onSubmit={e => { e.preventDefault(); handleSmtpSave(); }}
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">SMTP Host</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#52ab98]"
                    value={smtpForm.host}
                    onChange={e => handleSmtpInputChange('host', e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">SMTP Port</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#52ab98]"
                    value={smtpForm.port}
                    onChange={e => handleSmtpInputChange('port', e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">SMTP User</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#52ab98]"
                    value={smtpForm.user}
                    onChange={e => handleSmtpInputChange('user', e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">SMTP Password</label>
                  <input
                    type="password"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#52ab98]"
                    value={smtpForm.pass}
                    onChange={e => handleSmtpInputChange('pass', e.target.value)}
                    required
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">From Email</label>
                  <input
                    type="email"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#52ab98]"
                    value={smtpForm.from}
                    onChange={e => handleSmtpInputChange('from', e.target.value)}
                    required
                  />
                </div>
                <div className="md:col-span-2 flex flex-col sm:flex-row gap-2 mt-2">
                  <button
                    type="submit"
                    className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg flex items-center justify-center gap-2"
                    disabled={smtpLoading}
                  >
                    <FaSave /> Save SMTP Settings
                  </button>
                  <button
                    type="button"
                    className="bg-gray-400 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center justify-center gap-2"
                    onClick={() => { setSmtpForm(smtpSettings || { host: '', port: '', user: '', pass: '', from: '' }); setSmtpMode(smtpSettings ? 'view' : 'add'); setSmtpError(''); setSmtpSuccess(''); }}
                    disabled={smtpLoading}
                  >
                    <FaTimes /> Cancel
                  </button>
                </div>
              </form>
            )}
          </div>
        )}
      </div>
    </main>
    {/* Custom CSS for animations */}
    <style jsx>{`
      @keyframes fade-in {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      
      @keyframes slide-in-left {
        from { transform: translateX(-100px); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      
      @keyframes slide-in-right {
        from { transform: translateX(100px); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      
      @keyframes fade-in-up {
        from { transform: translateY(50px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      
      .animate-fade-in {
        animation: fade-in 0.6s ease-out;
      }
      
      .animate-slide-in-left {
        animation: slide-in-left 0.8s ease-out;
      }
      
      .animate-slide-in-right {
        animation: slide-in-right 0.8s ease-out;
      }
      
      .animate-fade-in-up {
        animation: fade-in-up 1s ease-out;
      }
    `}</style>
  </div>
);
};
export default Profile;